import { TableColumn } from '@/modules/entity-details/models/TableColumn.model';

export const customPropertyEquipmentColumns: TableColumn[] = [
    {
        name: 'description',
        field: 'description',
        label: 'Description',
        tooltipData: {
            content: '',
        },
    },
    {
        name: 'rentalId',
        field: 'rentalId',
        label: 'Rental ID',
        tooltipData: {
            content: '',
        },
    },
    {
        name: 'equipmentValue',
        field: 'equipmentValue',
        label: 'Equipment Value',
        tooltipData: {
            content: '',
        },
    },
    {
        name: 'rentalCompleteDate',
        field: 'rentalCompleteDate',
        label: 'Rental Complete Date',
        tooltipData: {
            content: '',
        },
    },
    {
        name: 'rentalProtectionPlan',
        field: 'rentalProtectionPlan',
        label: 'Rental Protection Plan',
        tooltipData: {
            content: '',
        },
    },
    {
        name: 'action',
        label: '',
    },
];
